import { c as _c } from "react-compiler-runtime";
import { createContext, useEffect, useState, useCallback, useMemo } from 'react';
import { fetchUserAttributes } from 'collaboration-sidebar/api/UserSettings';
import { getUserAttributesArray } from '../constants/userAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_STATE = {
  loading: true,
  error: null,
  settings: undefined
};
export const UserSettingsContext = /*#__PURE__*/createContext(Object.assign({}, INITIAL_STATE, {
  setState: () => {}
}));
export default function UserSettingsProvider(t0) {
  "use memo";

  const $ = _c(10);
  const {
    children,
    objectId
  } = t0;
  const [state, setState] = useState(INITIAL_STATE);
  let t1;
  if ($[0] !== objectId) {
    t1 = () => {
      if (!objectId) {
        return;
      }
      setState({
        loading: true,
        error: null
      });
      const keysToFetch = getUserAttributesArray();
      fetchUserAttributes(keysToFetch).then(payload => {
        const settingsArr = Object.keys(payload).reduce((acc, key) => {
          acc.push({
            key,
            value: payload[key]
          });
          return acc;
        }, []);
        setState({
          loading: false,
          error: null,
          settings: settingsArr
        });
      }).catch(error => {
        setState({
          loading: false,
          error,
          settings: undefined
        });
      });
    };
    $[0] = objectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fetchUserSettings = t1;
  let t2;
  let t3;
  if ($[2] !== fetchUserSettings) {
    t2 = () => {
      fetchUserSettings();
    };
    t3 = [fetchUserSettings];
    $[2] = fetchUserSettings;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== state) {
    t4 = Object.assign({}, state, {
      setState
    });
    $[5] = state;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const userSettingsState = t4;
  let t5;
  if ($[7] !== children || $[8] !== userSettingsState) {
    t5 = /*#__PURE__*/_jsx(UserSettingsContext.Provider, {
      value: userSettingsState,
      children: children
    });
    $[7] = children;
    $[8] = userSettingsState;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}